import segmentProps from '../lib/segmentProps';

export default {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_report_history_selected',
            props: {
                ...segmentProps,
                report_state: '@events.report_state',
                report_view_state: '?@events.report_view_state',
                report_month: '?@events.report_month',
                pending_changes: '@events.pending_changes',
                user_state: '@events.user_state',
            },
        },
    },
};
